export const messages = {
  page: {
    title: {
      id: 'updatePassword.Page.Title',
      defaultMessage: 'Change Your Password',
    },
  },
};
